//packages
import React, {Component} from 'react'
import {connect} from 'react-redux'

//common
import LoadingBar from '../../common/LoadingBar'
import AlertError from '../../common/AlertError'
import UpdateFromPacer from '../../common/UpdateFromPacer'

//results
import SearchReceipt from '../../search/results/searchReceipt/SearchReceipt'


//actions
import * as irActions from '../../../redux/actions/irSearch'

class NoticeOfBankruptcyCaseFiling extends Component {

    componentDidMount() {
        if (this.props.purchase_right_away)
            this.purchaseNotice()
        else
            this.getNotice()
    }

    getNotice() {
        console.log('fetching notice from cache');
        this.props.dispatch(irActions.getCaseData({ type: 'notice', case_uuid: this.props.case_uuid }))
    }

    purchaseNotice() {
        console.log('purchasing notice from pacer');
        this.props.dispatch(irActions.purchaseCaseData({ type: 'notice', case_uuid: this.props.case_uuid }))
    }

    render() {
        if (!this.props.dataReady) return <LoadingBar/>;

        const errorMessage = this.props.error ? <AlertError errors={ this.props.error } /> : null

        const {receipt} = this.props;
        return (
            <div>
                { errorMessage }
                <div className="ir-search-query" dangerouslySetInnerHTML={{__html: this.props.notice }}></div>

                { receipt ?
                    <SearchReceipt receipt={receipt}/> : null
                }

                <UpdateFromPacer
                    pacerUpdateHandler={ this.purchaseNotice.bind(this) }
                    pacerReceipt={receipt}
                    lastUpdated={this.props.lastUpdated}/>
            </div>
        )
    }
}

function mapStateToProps(state) {
    const irSearch = state.get('irSearch');

    return {
        dataReady: irSearch.get('data_ready'),
        notice: irSearch.get('data'),
        receipt: irSearch.receipt,
        error: irSearch.get('error'),
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch: dispatch
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(NoticeOfBankruptcyCaseFiling)



/** WEBPACK FOOTER **
 ** ./src/components/case/notice/NoticeOfBankruptcyCaseFiling.js
 **/